import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'practice-template/:teamId/templates/create/new(:/view)',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/TemplateNewContainer',
      './modules/templateNew'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const TemplateNew = require('./containers/TemplateNewContainer').default
      const actions = require('./modules/templateNew')
      const reducer = require('./modules/templateNew').default

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'templateCreationNew', reducer: reducer })

      store.dispatch(actions.initialize())
      store.dispatch(actions.fetchData(nextState.params.teamId))

      /*  Return getComponent   */
      cb(null, TemplateNew)

    /* Webpack named bundle   */
    }, 'templateCreationNew')
  }
})



// WEBPACK FOOTER //
// ./src/routes/CreateTemplate/components/TemplateNew/index.js